import { render, staticRenderFns } from "./BannerSmall.vue?vue&type=template&id=baf177a4&"
import script from "./BannerSmall.vue?vue&type=script&lang=js&"
export * from "./BannerSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports